// extracted by mini-css-extract-plugin
export default {"phoneWidth":"768px","smallPhoneWidth":"360px","tabletWidth":"1024px"};